import { HeaderColor } from 'src/types/global-types';

export const useHeaderColor = (): HeaderColor => {
    //const treatment = 'off';

    //const backgroundColor = treatment === 'on' ? 'alternateColor' : 'orange';
    const backgroundColor = 'orange';

    return backgroundColor;
};
